export default __webpack_public_path__ + "static/media/video-earth.39e6c79b.mp4";